import axios from "axios";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

const cache = {};
let middlewareCache = null;

const cachedToken = () => {
  const exp = JSON.parse(atob(cache.data?.token?.split(".")[1] || "e30=")).exp || 0;
  return (exp - 300) * 1000 > Date.now() ? cache.data.token : "";
};

const getAiToken = async () => {
  const token = cachedToken();
  if (!token && !cache.promise) {
    cache.promise = caseTransformingAxios
      .post("/api/v4/ai_assist/token")
      .then((res) => {
        cache.promise = null;
        cache.data = res.data;
        return res.data;
      })
      .catch(() => ({ apiUrl: "", token: "", crmAccessToken: "" }));
  }
  return (token && cache.data) || cache.promise;
};

const authInterceptor = async (config) => {
  const { token } = await getAiToken();
  return {
    ...config,
    paramsSerializer: { indexes: null },
    headers: { ...config.headers, Authorization: `Bearer ${token}` },
  };
};

const getExternalApi = (apiUrl) => {
  if (cache[apiUrl]) return cache[apiUrl];

  cache[apiUrl] = axios.create({ baseURL: apiUrl });
  cache[apiUrl].interceptors.request.use(authInterceptor);
  return cache[apiUrl];
};

const getMiddlewareConfig = async () => {
  const minAuthTimeLeftInSeconds = 15;

  if (!middlewareCache || middlewareCache.expiresAt - Date.now() / 1000 < minAuthTimeLeftInSeconds) {
    const response = await caseTransformingAxios.post("/brivity_middleware_tokens");
    middlewareCache = response.data;
  }

  return middlewareCache;
};

const getMiddlewareApi = async () => {
  const middlewareConfig = await getMiddlewareConfig();
  const api = axios.create({
    baseURL: middlewareConfig.middlewareApi,
    headers: { Authorization: `Bearer ${middlewareConfig.encoded}` },
  });

  return api;
};

export { getAiToken, getExternalApi, getMiddlewareApi };
